import { Button, useMutation, useNotify, useRefresh } from "react-admin";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";
import { IConfirmStudentRenewalButton } from "./ConfirmStudentRenewalButton";

const DeclineButton = ({
  id,
  studentId,
  academicYearId,
}: IConfirmStudentRenewalButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleDeclineStudentRenewal, { loading }] = useMutation(
    {
      type: "update",
      resource: `studentRenewals`,
      payload: {
        id: id,
        data: {
          isAcceptRenewal: false,
          studentId: studentId,
          academicYearId: academicYearId,
        },
      },
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully decline student renewal.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed accept decline renewal, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={handleDeclineStudentRenewal}
      color="primary"
      label={loading ? "Please wait..." : "Decline"}
      style={{ backgroundColor: "#f44336" }}
    >
      <CloseIcon />
    </Button>
  );
};

export default DeclineButton;
